import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Table } from 'semantic-ui-react';
import { MorristownWater } from '../types';
import { TableHeader } from './TableHeader';

interface PropTypes {
  morristownWater: MorristownWater[];
}

const TableRow = ({ morristownWater: morristownWater }: { morristownWater: MorristownWater }) => (
  <Table.Row>
    <Table.Cell collapsing>{morristownWater.account}</Table.Cell>
    <Table.Cell collapsing>{morristownWater.status}</Table.Cell>
    <Table.Cell collapsing>{morristownWater.fullName}</Table.Cell>
    <Table.Cell collapsing>{morristownWater.location }</Table.Cell>
    <Table.Cell collapsing>{morristownWater.city}</Table.Cell>
    <Table.Cell collapsing>{morristownWater.zip}</Table.Cell>
    <Table.Cell collapsing>{morristownWater.block}</Table.Cell>
    <Table.Cell collapsing>{morristownWater.lot}</Table.Cell>
    <Table.Cell collapsing>{moment(morristownWater.readDate).format('MM/DD/YYYY')}</Table.Cell>
    <Table.Cell collapsing>{moment(morristownWater.lastPayDate).format('MM/DD/YYYY')}</Table.Cell>
    <Table.Cell collapsing>{morristownWater.lastPayAmount}</Table.Cell>
    <Table.Cell collapsing>{moment(morristownWater.dueDate).format('MM/DD/YYYY')}</Table.Cell>
    <Table.Cell collapsing>{morristownWater.totalDue}</Table.Cell>
    <Table.Cell collapsing>{moment(morristownWater.billDate).format('MM/DD/YYYY')}</Table.Cell>
    <Table.Cell collapsing>{morristownWater.billAmount}</Table.Cell>
  </Table.Row>
);

const MorristownWater = (props: PropTypes) => {
  const [sortedMorristownWater, setSortedMorristownWater] = useState<MorristownWater[]>([]);

  useEffect(() => {
    if (props.morristownWater) {
      setSortedMorristownWater(props.morristownWater);
    }
  }, [props.morristownWater]);
  return (
    <React.Fragment>
      {sortedMorristownWater.length === 0 ? (
        <div>No Records Available</div>
      ) : (
        <Table striped columns={12} sortable>
          <TableHeader
            columnNames={[
              'Account',
              'Status',
              'Full Name',
              'Location',
              'City',
              'Zip',
              'Block',
              'Lot',
              'Read Date',
              'Last Payment Date',
              'Last Payment Amount',
              'Due Date',
              'Total Due',
              'Bill Date',
              'Bill Amount',
            ]}
            sortedData={sortedMorristownWater}
            setSortedData={setSortedMorristownWater}
          />
          <Table.Body>
            {sortedMorristownWater.map(morristownWater => (
              <TableRow morristownWater={morristownWater} />
            ))}
          </Table.Body>
        </Table>
      )}
    </React.Fragment>
  );
};

export default MorristownWater;
